import { CourseForm } from "../types/forms/course-form";

const CODE_POSTAL_BRUXELLES_MIN = 1000;
const CODE_POSTAL_BRUXELLES_MAX = 1299;

/** Codes postaux assimilés à Bruxelles bien que hors Région : Brussels Airport (Zaventem). */
const CODES_POSTAUX_ASSIMILES_BRUXELLES = [1930];

/**
 * Appartenance à la Région de Bruxelles-Capitale, d'après le code postal.
 *
 * Reprend volontairement la règle que le backend tient dans `ZoneGeographique` :
 * le formulaire doit pouvoir fermer un choix avant tout aller-retour serveur.
 * Le backend reste seul juge et refuse le cas échéant (erreur 13023).
 */
export const estDansBruxelles = (codePostal?: string | null): boolean => {
  const normalise = codePostal?.trim();
  if (!normalise) return false;

  const cp = Number(normalise);
  if (!Number.isInteger(cp)) return false;

  return (
    (cp >= CODE_POSTAL_BRUXELLES_MIN && cp <= CODE_POSTAL_BRUXELLES_MAX) ||
    CODES_POSTAUX_ASSIMILES_BRUXELLES.includes(cp)
  );
};

/**
 * Code postal de la prise en charge : l'arrêt d'ordre le plus faible, qui n'est
 * pas nécessairement le premier de la liste. Chaîne vide tant qu'aucune adresse
 * n'est saisie.
 */
export const codePostalDepart = (arrets?: CourseForm["arrets"]): string => {
  const depart = (arrets ?? []).reduce<CourseForm["arrets"][number] | null>(
    (plusPetit, arret) =>
      plusPetit === null || arret.ordre < plusPetit.ordre ? arret : plusPetit,
    null,
  );

  return depart?.adresse?.codePostal?.trim() ?? "";
};
